import { supabase } from '../supabaseClient';

/**
 * Fetch avec authentification automatique.
 * Récupère le token Supabase et l'ajoute au header Authorization.
 */
export const fetchWithAuth = async (url, options = {}) => {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  });
};
